module.exports = __webpack_public_path__ + "assets/img/step2.078660ad.png";